<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryDataGroup, append, queryDataGroupById, delteDatagroup, setReference } from '../../../../../api/home.js';
export default {
	name: 'ACSetManagement',
	data() {
		return {
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('ACSetManagementheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('ACSetManagementoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			/* 表格 */
			title: '新增账套',
			analyse: false,
			FormData: {
				groupName: '',
				description: '',
				accountLevel: [{ level: '', length: '' }]
			},
			rules: {
				groupName: [{ required: true, message: '请输入账套名称', trigger: 'blur' }],
				description: [{ required: true, message: '请输入账套描述', trigger: 'blur' }]
			},
			Count: 0
		};
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('ACSetManagementoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('ACSetManagementheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//设置引用
		shezhiyingyong() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择要设置的数据');
				return;
			}
			if (this.$refs.tablebox.getSelectionval().length > 1) {
				this.$message.error('只能选择一条数据');
				return;
			}
			this.$showConfirm({
				message: '确认设置引用吗?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					params.id = this.$refs.tablebox.getSelectionval()[0].id;
					setReference(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('设置成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//删除
		deleteTCode(id) {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					params.ids = id;
					delteDatagroup(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//唤醒新增编辑弹框
		analysehx(id) {
			if (id == '-1') {
				this.title = '新增账套';
				this.FormData = {
					id: null,
					groupName: '',
					description: '',
					accountLevel: [{ level: '', length: '' }]
				};
				this.analyse = true;
			} else {
				let params = {};
				params.id = id;
				queryDataGroupById(params).then(res => {
					if ((res.data.code = '200')) {
						this.FormData = res.data.data;
						this.FormData.id = res.data.data.id;
						this.FormData.groupName = res.data.data.groupName;
						this.FormData.description = res.data.data.description;
						this.FormData.accountLevel = JSON.parse(res.data.data.accountLevel);
						this.analyse = true;
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
			this.$nextTick(() => {
				this.$refs['FormData'].clearValidate();
			});
		},
		//保存
		analysebc() {
			this.$refs.FormData.validate(valid => {
				if (valid) {
					let params = {};
					params.data = JSON.stringify(this.FormData);
					append(params).then(res => {
						if (res.data.code == '200') {
							this.analyse = false;
							this.searrchForData();
							this.$message.success('保存成功');
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		//加一行
		ADD(k) {
			this.FormData.accountLevel.splice(k + 1, 0, { level: '', length: '' });
		},
		//删一行
		del(k) {
			if (this.FormData.accountLevel.length == 1) {
				this.FormData.accountLevel = [{ level: '', length: '' }];
			} else {
				this.FormData.accountLevel.splice(k, 1);
			}
		},
		searrchForData() {
			let params = {
				page: this.pagination.pageNum,
				rows: this.pagination.pageSize,
				sort: '',
				order: '',
				criteriaJson: JSON.stringify(this.searchdata)
			};
			inquiryDataGroup(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				}
			});
		},

		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
